import { BookingTaxEstimateInterface } from '@sport-activities/sdk';
import { Component, Input, OnInit } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';

import { CheckoutItem } from '~/checkout/model/checkout-item.model';
import { ParamethorNameEnum } from '~/paramethor/names.enum';
import { ParamethorService } from '~/paramethor/paramethor.service';
import { PromoCodeService } from '~/payment/services/promocode/promocode.service';
import { CheckoutService } from '~/checkout/services/checkout/checkout.service';

@Component({
  selector: 'app-summary-detail',
  templateUrl: './summary-detail.component.html',
})
export class SummaryDetailComponent implements OnInit {
  @Input() public isCart = false;
  @Input() public isVatDisplayed: boolean;
  @Input() public item: CheckoutItem;
  @Input() public items: CheckoutItem[] = [];
  @Input() public showExternalPayment = false;
  @Input() public taxes: BookingTaxEstimateInterface;

  public hasPromoCode = false;
  public isVatShown = false;
  public originalItem: CheckoutItem[];
  public taxesDetail;

  constructor(
    private readonly checkoutService: CheckoutService,
    private readonly promoCodeService: PromoCodeService,
    private readonly paramethorService: ParamethorService,
    private readonly translateService: TranslateService
  ) {}

  ngOnInit(): void {
    this.getTaxesDetail();

    if (this.isPromoCodeEnabled) {
      const previousCode = JSON.parse(this.promoCodeService.loadPromoCode());

      if (previousCode) {
        this.hasPromoCode = true;
        this.originalItem = this.checkoutService
          .getCartContent()
          .filter((cartItem) => {
            return (
              cartItem.timeslot.identifier === this.item.timeslot.identifier
            );
          });
      }
    }
  }

  public get isPromoCodeEnabled(): boolean {
    return this.paramethorService.isTrue(ParamethorNameEnum.PromoCode);
  }

  public getAdultsTotalPrice(item) {
    if (this.isPromoCodeEnabled && this.hasPromoCode) {
      return this.originalItem[0]?.adultsTotalPrice;
    }
    return item?.adultsTotalPrice;
  }

  public getChildrenTotalPrice(item) {
    if (this.isPromoCodeEnabled && this.hasPromoCode) {
      return this.originalItem[0]?.childrenTotalPrice;
    }
    return item?.childrenTotalPrice;
  }

  public getTaxesDetail() {
    this.taxesDetail = this.taxes?.details.find(
      (o) => o.sku === this.item?.timeslot.identifier
    );

    return this.taxesDetail;
  }

  public numberOfPlaces(places: number, type: string): void {
    const publicType = places === 1 ? type : `${type}s`;
    return this.translateService.instant(
      `checkout.payment.summary.${publicType}`
    );
  }
}
